import { useContext } from 'react';
import { ToastContext, ToastContextType } from '../contexts/ToastContext';

export const useToastContext = () => {
    return useContext(ToastContext) as ToastContextType;
};
